// トップページのjs

import "../sass/page-top.scss";

import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.css";
import ScrollHint from "scroll-hint";
import "scroll-hint/css/scroll-hint.css";

import { celebrate } from "../jsmodules/celebrate";

const scrollbarFn = () => {
	const targets = document.querySelectorAll(".js-sb");
	if (targets.length === 0) return;

	// prettier-ignore
	Array.prototype.forEach.call(
		targets,
		(target) => new SimpleBar(target, {
				autoHide: false,
				scrollbarMaxSize: 150,
			}),
	);
};

// 横スクロールのヒント
const scrollHintFn = () => {
	const targets = document.querySelectorAll(".js-scrollable");
	if (targets.length === 0) return;

	const items = [...targets].map((el) => el.querySelector(".simplebar-content-wrapper") || el);

	// eslint-disable-next-line no-new
	new ScrollHint(items, {
		scrollHintIconAppendClass: "scroll-hint-icon-white",
		i18n: {
			scrollable: "スクロールできます",
		},
	});
};

document.addEventListener("DOMContentLoaded", () => {
	scrollbarFn();
	scrollHintFn();
});

// ローディング後に紙吹雪
const startCelebrate = () => setTimeout(celebrate, 600);
if (document.documentElement.classList.contains("is-loading")) {
	window.addEventListener("site:loaded", startCelebrate, { once: true });
} else {
	window.addEventListener("load", startCelebrate, { once: true });
}
